window.addEventListener('load', function () {
     setTimeout(function() {
        document.getElementById('header').style.pointerEvents = 'auto';
        console.log('sssaaas');
    }, 3000); // 4000 milliseconds = 4 seconds
});


// Detect iOS (iPhone / iPod / iPad in Safari)
var isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        if (document.body.style.overflow === 'hidden') {
          setTimeout(function() {document.body.style.position = 'fixed';}, 100);
        } else {
          document.body.style.position = '';
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
}